export const baseUrl = '/api/v1/';
// export const baseUrl = 'https://rwtestadminui.azurewebsites.net/api/v1/';
// export const baseUrl = 'http://localhost:7000/api/v1/';
export const version = '1.0.0';
 

   